import React from 'react';
import { Container } from '../../atoms/container/Container';
import { Text } from '../../atoms/text/Text';
import CustomSelect from '../../atoms/select/CustomSelect';
import { Flex } from 'antd';
import style from './AmbulanceType.module.scss';
interface AmbulanceTypeProps {
    pocoRateCard: any[];
    handleAmbulanceType: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    selectedAmbulanceType: string;
    disable?: boolean
}


export const AmbulanceType: React.FC<AmbulanceTypeProps> = ({ pocoRateCard, handleAmbulanceType, selectedAmbulanceType, disable }) => {
    // console.log('pocoRateCard:', pocoRateCard);
    return (
        <Container className={style.horizon_wrapper}>
            <Container className={style.label}>
                <Text text="Ambulance Type:" className={style.title} />
            </Container>
            <Container className={style.input_wrapper}>
                <Flex gap={10} align="center">
                    <CustomSelect width={"100%"} height={"40px"} placeHolder={""} options={pocoRateCard} onChange={(e:any)=>handleAmbulanceType(e)} value={selectedAmbulanceType} disable={disable} />
                </Flex>
            </Container>
        </Container >
    )
}